import React, { useState } from 'react';
import Container from '../components/Container';
import Reveal from '../components/Reveal';
import ResearchCard from './ResearchCard';
import ResearchModal from '../components/ResearchModal';

// §7.4.2 — two-column grid of research cards; "View Research" opens a dossier modal.
export default function ResearchGrid({ items }) {
  const list = (items || []).slice().sort((a, b) => a.order - b.order);
  const [active, setActive] = useState(null);
  if (!list.length) return null;
  return (
    <div className="research-section">
      <Container>
        <div className="research-grid">
          {list.map((item, i) => (
            <Reveal key={item.id} delay={(i % 2) * 120}>
              <ResearchCard item={item} onOpen={setActive} />
            </Reveal>
          ))}
        </div>
      </Container>

      {active && <ResearchModal item={active} onClose={() => setActive(null)} />}
    </div>
  );
}
